const slugify = (value) =>
  value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

const getWordCount = (element) => {
  const text = element.textContent.trim();
  return text ? text.split(/\s+/).length : 0;
};

const getHeadingId = (heading, index, occupiedIds, assignedIds) => {
  const currentId = heading.id.trim();

  if (currentId && !occupiedIds.has(currentId) && !assignedIds.has(currentId)) {
    assignedIds.add(currentId);
    return currentId;
  }

  const baseId = `article-${slugify(heading.textContent) || `section-${index + 1}`}`;
  let headingId = baseId;
  let suffix = 2;

  while (occupiedIds.has(headingId) || assignedIds.has(headingId)) {
    headingId = `${baseId}-${suffix}`;
    suffix += 1;
  }

  heading.id = headingId;
  assignedIds.add(headingId);
  return headingId;
};

const initializeArticleToc = (toc) => {
  if (toc.dataset.tocReady === 'true') return;
  const articleTemplate = toc.closest('.article-template');
  const articleContent = articleTemplate?.querySelector('[data-article-content]');
  const tocList = toc.querySelector('[data-article-toc-list]');
  const details = toc.querySelector('.article-toc__details');

  if (!articleContent || !tocList || !details) return;

  const existingToc = articleContent.querySelector('nav, .toc, .table-of-contents, [data-article-toc]');
  if (existingToc?.querySelector('a[href^="#"]')) return;

  const headings = [...articleContent.querySelectorAll('h2')].filter(
    (heading) => heading.textContent.trim() !== ''
  );
  const minimumHeadings = Number(toc.dataset.minHeadings) || 4;
  const minimumWords = Number(toc.dataset.minWords) || 1000;
  const shouldShow =
    headings.length >= minimumHeadings || (headings.length >= 3 && getWordCount(articleContent) >= minimumWords);

  if (!shouldShow) return;

  const headingElements = new Set(headings);
  const occupiedIds = new Set(
    [...document.querySelectorAll('[id]')]
      .filter((element) => !headingElements.has(element))
      .map((element) => element.id)
      .filter(Boolean)
  );
  const assignedIds = new Set();
  const fragment = document.createDocumentFragment();

  headings.forEach((heading, index) => {
    const headingId = getHeadingId(heading, index, occupiedIds, assignedIds);
    const item = document.createElement('li');
    const link = document.createElement('a');

    link.href = `#${headingId}`;
    link.textContent = heading.textContent.trim();
    item.append(link);
    fragment.append(item);
  });

  tocList.replaceChildren(fragment);
  toc.dataset.tocReady = 'true';
  details.open = window.matchMedia('(min-width: 750px)').matches;
  toc.hidden = false;

  tocList.addEventListener('click', (event) => {
    const link = event.target.closest('a');
    if (link && window.matchMedia('(max-width: 749px)').matches) {
      details.open = false;
    }
    if (link) {
      const target = document.getElementById(decodeURIComponent(link.hash.slice(1)));
      if (target) {
        event.preventDefault();
        if (window.location.hash !== link.hash) history.pushState(history.state, '', link.hash);
        target.tabIndex = -1;
        target.scrollIntoView({ behavior: 'instant', block: 'start' });
        target.focus({ preventScroll: true });
      }
    }
  });
};

const initializeArticleTocs = () => {
  document.querySelectorAll('[data-article-toc]').forEach(initializeArticleToc);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeArticleTocs, { once: true });
} else {
  initializeArticleTocs();
}

document.addEventListener('shopify:section:load', initializeArticleTocs);
